module.exports = __webpack_public_path__ + "static/media/add route.c42e7d4a.svg";